import { Component, OnInit, Input } from '@angular/core';
import { FindInspectionService } from '../../services/find-inspection.service';
import { InspectionRowViewModel } from '../../models/find-inspection.model';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'unsynced-inspection-list-row',
  templateUrl: './unsynced-inspection-list-row.component.html',
  styleUrls: ['./unsynced-inspection-list-row.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class UnsyncedInspectionListRowComponent implements OnInit {
  @Input() inspectionId: number;
  public inspection: InspectionRowViewModel;
  public loadingRow: boolean = true;

  constructor(private _findInspection: FindInspectionService,
    private _router: Router) { }

  ngOnInit() {
    //this.loadRowData();
  }

  loadRowData() {
    this._findInspection.getUnsyncedInspectionRow(this.inspectionId).subscribe(r => {
      this.inspection = r;
      this.loadingRow = false;
    });
  }

  openInspection() {
    // this._router.navigate(['/unsyncedinspection', this.inspectionId]);
    window.open('/unsyncedinspection/' + this.inspectionId, '_blank');
  }
}
